import { render } from "./FormLibros.vue?vue&type=template&id=71f49a94&scoped=true"
import script from "./FormLibros.vue?vue&type=script&lang=js"
export * from "./FormLibros.vue?vue&type=script&lang=js"

import "./FormLibros.vue?vue&type=style&index=0&id=71f49a94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71f49a94"

export default script